import _ from 'lodash';
import { uuid2 as uuid } from '@/utils';

class GraphicBase {
  constructor(payload, stage) {
    this.id = payload.id ? payload.id : uuid();
    this.type = payload.type;
    this.data = payload.data;
    this.group_id = payload.group_id;
    this.group_type = payload.group_type;
    this.property = payload.property;

    this.ele = null;
    this.layer = null;
    this.canDraggable = false;
    this.stage = stage;

    this.build();
  }

  // eslint-disable-next-line class-methods-use-this
  updateEle() {}

  // eslint-disable-next-line class-methods-use-this
  setSelected(selected) {}

  update(target) {
    this.property = _.extend(this.property, target.property);
    if (this.property.type === '4') {
      this.group_type = 'Screen';
    }
    if (this.property.type === '2') {
      this.group_type = 'Escalator';
      if (this.property.category_2 === '1') {
        this.group_type = 'WalkingLadder';
      }
      if (this.property.category_2 === '2') {
        this.group_type = 'Elevator';
      }
    }
    if (this.property.type === '12') {
      this.group_type = 'Crossroads';
    }
    if (this.property.type === '13') {
      this.group_type = 'AreaCenter';
    }
    if (this.property.type === '18') {
      this.group_type = 'Junction';
    }
    this.ele.destroy();
    this.build();
    this.stage.changeTransformNodes(this.ele);
    if (this.stage.view === 'selection') {
      if (this.canDraggable) {
        this.ele.draggable(true);
      }
    }
  }

  toObject() {
    return {
      graphic_data: _.cloneDeep(this.data),
      graphic_id: this.id,
      graphic_type: this.type,
      group_id: this.group_id,
      group_type: this.group_type,
      property: _.cloneDeep(this.property),
    };
  }
}

export default GraphicBase;
